import { css } from 'linaria';

export namespace styles {
  export const articleContainer = css`
    width: 100%;
    margin-bottom: var(--space-150);
    color: var(--text-minor);
    letter-spacing: 2px;
    height: var(--space-200);
    &::after {
      content: '';
      display: block;
    }
  `;
  export const displayedNameContainer = css`
    color: var(--text-primary);
    word-break: break-word;
  `;
  export const copyIconClass = css`
    cursor: pointer;
    svg {
      top: 75%;
      left: 25%;
    }
  `;
}
